<script>
import BaseConfig from './_base-config.vue';
import { mapState } from 'vuex';

export default {
  name: 'AudioConferencingAdd2Cart',
  extends: BaseConfig,
  created() {
    this.handlePageFristLoad()
  },
  computed: {
    ...mapState({
      refreshCount: state => state.ShoppingCart.refreshCount
    })
  },
  methods: {
    handlePageFristLoad() {
      if (this.refreshCount > 1) return
      if (this.mx_showUnlimited) this.mx_handleUnlimitedShow()
    }
  },
};
</script>
